export const LETS_GO = 'LETS_GO';
export const CHANGE_COLOR = 'CHANGE_COLOR';
export const CUSTOM_EDIT = 'CUSTOM_EDIT';
export const EXPERIENCE_PUT = 'EXPERIENCE_PUT';
export const EXPERIENCE_GET = 'EXPERIENCE_GET';

